import { Context } from '@nuxt/types';
import GetGameClientJWTQuery from '../queries/gameClientJWT.gql';
import { setRedirectAfterLogin } from '../utils/redirectAfterLogin';

export default async function(context: Context) {
  const { redirect, query, app } = context;

  const { redirect_uri, client_id, action } = query;
  const callback = `/game-auth/?action=login&redirect_uri=${redirect_uri}&client_id=${client_id}`;
  const params = {
    audience: process.env.auth0Audience as string,
  } as any;

  await new Promise(async () => {
    try {
      if (!client_id) {
        throw new Error('Missing client_id');
      } else if (!redirect_uri) {
        throw new Error('Missing redirect_uri');
      }
      // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
      const token = app.$auth.strategy.token.get();
      if (action === 'register') {
        params.screen_hint = 'signup';
      }

      if (!token) {
        setRedirectAfterLogin(callback);
        await app.$auth.loginWith('auth0', { params });
        return;
      } else {
        const gameToken = await getGameToken(context, token);
        if (gameToken) {
          return redirect(`${redirect_uri}?token=${gameToken}`);
        } else {
          throw new Error('Game token not found');
        }
      }
    } catch (error) {
      const message =
        error.message?.replace('GraphQL error: ', '') || JSON.stringify(error);
      app.$sentry.captureException(error);
      if (message !== 'ERR_REDIRECT') {
        return redirect(`${redirect_uri}?error=${message}`);
      }
    }
  });
}

async function getGameToken(context: Context, token: string) {
  const { app, query } = context;

  if (app.apolloProvider) {
    const client = app.apolloProvider.defaultClient;
    const fetchPolicy = 'network-only';
    const { data } = await client.query({
      query: GetGameClientJWTQuery,
      variables: {
        client_id: query.client_id,
        redirect_uri: query.redirect_uri,
        mpDistinctId: app.$mixpanel.get_distinct_id(),
      },
      context: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      fetchPolicy,
    });
    if (data.getGameClientJWT?.token) {
      return data.getGameClientJWT?.token;
    } else {
      throw new Error('Game token not found');
    }
  }
}
